import { render, staticRenderFns } from "./LegacyWorkers.vue?vue&type=template&id=440efa6f&"
import script from "./LegacyWorkers.vue?vue&type=script&lang=js&"
export * from "./LegacyWorkers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports